import { Injectable } from '@angular/core';

const MAX_DEPTH = 4;
const REVOCATION_STATUS = 400;

@Injectable({ providedIn: 'root' })
export class CredentialRevocationService {
  // The OAuth library nests the real failure a few levels deep, and the shape differs per flow.
  public isRevocation(error: unknown): boolean {
    let current = error;
    let status: number | undefined;

    for (let depth = 0; depth < MAX_DEPTH; depth++) {
      if (typeof current !== 'object' || current === null) {
        return false;
      }

      if ('status' in current && typeof current.status === 'number') {
        status = current.status;
      }

      if ('error' in current) {
        if (current.error === 'invalid_grant') {
          // A gateway or a failing IdentityServer can echo the same body; only the token endpoint
          // rejecting the grant itself is worth an on-site re-login.
          return status === undefined || status === REVOCATION_STATUS;
        }

        current = current.error;
      } else if ('reason' in current) {
        current = current.reason;
      } else {
        return false;
      }
    }

    return false;
  }
}
